<div class="one-left-panel">
  <div class="padding"></div>
  <div class="left-avatar">
    <one-avatar [username]="getUsername()" (click)="showAppList()"></one-avatar>
  </div>
  <div class="one-panel-item">
    <one-panel-item class="one-panel-item" label="leftPanel.panelItem.personal" iconClass="fas fa-user-circle" (click)="navigateToPersonalInfo()" [activated] = "currentRoute == 'personal'" ></one-panel-item>
  </div>

  <one-panel-item class="one-panel-item" label="leftPanel.panelItem.member" iconClass="fas fa-users" (click)="navigateToMemberList()" [activated]="currentRoute == 'members'"></one-panel-item>
  <one-panel-item class="one-panel-item" label="leftPanel.panelItem.group" iconClass="fas fa-users-cog" (click)="navigateToGroups()" [activated]="currentRoute == 'groups'"></one-panel-item>
  <one-panel-item class="one-panel-item" label="leftPanel.panelItem.guest" iconClass="fas fa-hat-cowboy" (click)="navigateToGuests()" [activated]="currentRoute == 'guests'"></one-panel-item>
  <!-- one-panel-item class="one-panel-item" label="leftPanel.panelItem.apps" iconClass="fas fa-layer-group"></!-->
  <div class="left-logout">
  <one-panel-item label="leftPanel.panelItem.logout" (click)="logout()"></one-panel-item>
  </div>
</div>
